import React from 'react';
import { Button } from 'antd';
import { fct } from '../../fct/tokens/tokens';

export const nf = new Intl.NumberFormat('es-ES');

/** Descarga un CSV (separador ';', BOM para Excel). */
export const exportCsv = (filename: string, headers: string[], rows: (string | number)[][]) => {
  const esc = (v: string | number) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const lines = [headers.map(esc).join(';'), ...rows.map((r) => r.map(esc).join(';'))];
  const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

/** Botón-filtro con estado activo: botón por defecto con `aria-pressed` y marca de selección (nunca varios primarios). */
export const FilterBtn: React.FC<{ active: boolean; onClick: () => void; children: React.ReactNode }> = ({
  active,
  onClick,
  children,
}) => (
  <Button
    size="small"
    aria-pressed={active}
    onClick={onClick}
    style={active ? { borderColor: fct.interaccion['seleccion-borde'], background: fct.interaccion['seleccion-fondo'], fontWeight: 600 } : undefined}
  >
    {children}
  </Button>
);

export const cmpNum = (a?: number, b?: number) => (a ?? 0) - (b ?? 0);
export const cmpTxt = (a?: string, b?: string) => (a ?? '').localeCompare(b ?? '');
